module.exports = __webpack_public_path__ + "static/img/aussteller_white.2fb532c3.svg";